/*
 *  -----------------------------------------------------------------------
 *    <copyright file="forecast-end-date-field/index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';
import { FieldSelector, Formats } from '@components/central-monitoring/field-selector';
import { useTranslation } from '@hooks/index';
import { RowDataSourceTable } from '@types/graphql-global-types';
import { getFieldsAndDataSources_OpraQueries_fields_FieldDefinition } from '@queries/generated/central-monitoring.generated';

interface ForecastEndDateFieldInterface {
    currentState: getFieldsAndDataSources_OpraQueries_fields_FieldDefinition[];
    error?: string;
    isRequired: boolean;
    onChange: Function;
    disabled?: boolean;
}

const ForecastEndDateField = ({
    currentState,
    error,
    disabled,
    isRequired,
    onChange,
}: ForecastEndDateFieldInterface) => {
    const { t } = useTranslation();

    return (
        <FieldSelector
            customClassName="add-visit-forecastEndDate"
            fieldSelect="forecastEndDate"
            onChange={(value: any) => onChange('forecastEndDate')({ target: { value } })}
            label={`${t('admin:forecastEndDate')}${isRequired ? '*' : ''}`}
            disabled={disabled}
            labelField="forecastEndDateField"
            customId="row-forecastEndDateField"
            value={currentState.map((field: any) => ({ ...field, id: field.key }))}
            error={error}
            dataSource={RowDataSourceTable.SUBJECT}
            formats={[Formats.Date, Formats.PartialDate]}
            isCalculated={false}
            multiselect
            excludeValue={(field: any) => currentState.findIndex((item: any) => item?.key === field?.key) < 0}
        />
    );
};

export default ForecastEndDateField;
